<template>
  <div class="live-picture">
    <div class="picture" :style="{ backgroundImage: `url('/static/img/live${pictureId}.jpg')` }"></div>
  </div>
</template>

<script>
import TweenMax from 'gsap/TweenMaxBase';
import animations from '../../assets/animations';
import { isTouchDevice } from '../../scripts/utils';

export default {
  name: 'LivePicture',

  props: ['picture-id'],

  data() {
    return {
      timeline: null,
    };
  },

  mounted() {
    this.$eventHub.$on('picture-hover', this.enter);
    this.$eventHub.$on('picture-leave', this.leave);
    this.$nextTick(() => {
      // if (!isTouchDevice()) {
      // TweenMax.set(this.$el, {
      //   yPercent: 30,
      //   // rotation: parseInt(this.pictureId, 10) % 2 === 0 ? -10 : 10,
      //   scaleY: 2,
      //   autoAlpha: 0,
      // });
      // this.timeline = animations.get('live-image')(this.$el);
      // }
    });
  },

  methods: {
    enter(event) {
      if (parseInt(this.pictureId, 10) === parseInt(event.id, 10)) this.timeline.play();
    },
    leave(event) {
      if (parseInt(this.pictureId, 10) === parseInt(event.id, 10)) this.timeline.reverse();
    },
  },
};
</script>

<style lang="scss" scoped>
.live-picture {
  .picture {
    width: 100%;
    height: 100%;
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
  }
}
</style>
